import useTestTag from '../../common/hooks/use-test-tag';
import OdinIcon, { type OdinIconName, OdinIconSize } from '../odin-icon/odin-icon.component';

export const OdinIconPosition = {
  Left: 0,
  Right: 1,
} as const;
export type OdinIconPosition = (typeof OdinIconPosition)[keyof typeof OdinIconPosition];

export interface OdinMenuItem {
  name: string;
  itemIconName: OdinIconName;
  itemIconPosition?: OdinIconPosition;
  menuItemText: string;
}

export interface OdinIconMenuItemProps extends OdinMenuItem {
  onClick: (name: string) => void;
}

export default function OdinIconMenuItem({
  name,
  itemIconName,
  itemIconPosition = OdinIconPosition.Left,
  menuItemText,
  onClick,
}: OdinIconMenuItemProps) {
  const tagCreator = useTestTag('odin-icon-menu');

  return (
    <div className="flex cursor-pointer items-center p-1 hover:bg-primary-5" onClick={() => onClick(name)}>
      {itemIconPosition === OdinIconPosition.Left && (
        <div className="mr-1 shrink">
          <OdinIcon icon={itemIconName} size={OdinIconSize.ExtraSmall} />
        </div>
      )}
      <div className="grow" ref={tagCreator(`${(menuItemText ?? '').replace(/\s+/g, '-').toLowerCase()}`)}>
        {menuItemText}
      </div>
      {itemIconPosition === OdinIconPosition.Right && (
        <div className="ml-1 shrink">
          <OdinIcon icon={itemIconName} size={OdinIconSize.ExtraSmall} />
        </div>
      )}
    </div>
  );
}
